module.exports = __webpack_public_path__ + "img/02012862003770.f44b13d7.png";